import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBrvrXQEhamPwWQJkH-fdm7XXHvLYBv_3o',
  authDomain: 'evonindustrial-453dd.firebaseapp.com',
  projectId: 'evonindustrial-453dd',
  storageBucket: 'evonindustrial-453dd.firebasestorage.app',
  messagingSenderId: '210051130841',
  appId: '1:210051130841:web:c8ebb618305a44682f25c8',
  measurementId: 'G-VPVE762TZH',
};

export const app = initializeApp(firebaseConfig);

export const analyticsPromise = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);
